import { refa_logo } from '@assets/icons';
import { PathnameEnum, styleConstant } from '@constant';
import { Box } from '@mui/material';
import { colorSet } from '@theme';
import { useNavigate } from 'react-router';
import { Text } from '../common/Text';

export const ImageUploaderMenuTop = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(PathnameEnum.IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_LIST_PAGE);
  };

  return (
    <>
      <Box
        style={{
          width: '100%',
          height: styleConstant.menuTopHeight,
          borderBottom: `1px solid ${colorSet.gray200}`,
          backgroundColor: colorSet.white,
          paddingLeft: 40,
          paddingRight: 80,
          display: 'inline-flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          position: 'fixed',
          left: 0,
          right: 0,
          top: 0,
          zIndex: styleConstant.zIndexMenuTop
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <img src={refa_logo} alt="" onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
          <Text variant="h3" style={{ marginLeft: 24 }}>
            이미지 업로더
          </Text>
        </div>
      </Box>
      <Box style={{ width: '100%', height: styleConstant.menuTopHeight }} />
    </>
  );
};
